import { render, staticRenderFns } from "./main-visual.vue?vue&type=template&id=2b0c1fc6&scoped=true"
import script from "./main-visual.vue?vue&type=script&lang=js"
export * from "./main-visual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0c1fc6",
  null
  
)

export default component.exports